import { defineMessages } from "react-intl";
export default defineMessages({
  settings: {
    "id": "settings.settings",
    "defaultMessage": "Settings"
  },
  // Section headers
  accountSection: {
    "id": "settings.accountSection",
    "defaultMessage": "Account",
    "description": "Section headers"
  },
  subscriptionSection: {
    "id": "settings.subscriptionSection",
    "defaultMessage": "Subscription"
  },
  integrationsSection: {
    "id": "settings.integrationsSection",
    "defaultMessage": "Integrations"
  },
  preferencesSection: {
    "id": "settings.preferencesSection",
    "defaultMessage": "Preferences"
  },
  notificationsSection: {
    "id": "settings.notificationsSection",
    "defaultMessage": "Notifications"
  },
  supportSection: {
    "id": "settings.supportSection",
    "defaultMessage": "Support"
  },
  // Menu items
  account: {
    "id": "settings.account",
    "defaultMessage": "Profile & Security",
    "description": "Menu items"
  },
  accountDescription: {
    "id": "settings.accountDescription",
    "defaultMessage": "Name, password, delete account"
  },
  profile: {
    "id": "settings.profile",
    "defaultMessage": "Profile"
  },
  appearance: {
    "id": "settings.appearance",
    "defaultMessage": "Appearance"
  },
  appearanceDescription: {
    "id": "settings.appearanceDescription",
    "defaultMessage": "Theme and display options"
  },
  units: {
    "id": "settings.units",
    "defaultMessage": "Units"
  },
  unitsDescription: {
    "id": "settings.unitsDescription",
    "defaultMessage": "Measurement units displayed within the application"
  },
  language: {
    "id": "settings.language",
    "defaultMessage": "Language"
  },
  languageDescription: {
    "id": "settings.languageDescription",
    "defaultMessage": "Preferred language"
  },
  contactUs: {
    "id": "settings.contactUs",
    "defaultMessage": "Contact Us"
  },
  contactUsDescription: {
    "id": "settings.contactUsDescription",
    "defaultMessage": "Get help or send feedback"
  },
  helpCenter: {
    "id": "settings.helpCenter",
    "defaultMessage": "Help Center"
  },
  helpCenterDescription: {
    "id": "settings.helpCenterDescription",
    "defaultMessage": "FAQs and guides"
  },
  about: {
    "id": "settings.about",
    "defaultMessage": "About"
  },
  aboutDescription: {
    "id": "settings.aboutDescription",
    "defaultMessage": "License agreement, privacy policy"
  },
  privacyPolicy: {
    "id": "settings.privacyPolicy",
    "defaultMessage": "Privacy policy"
  },
  termsOfService: {
    "id": "settings.termsOfService",
    "defaultMessage": "Terms of service"
  },
  updateYourProfile: {
    "id": "settings.updateYourProfile",
    "defaultMessage": "Update your profile"
  },
  update: {
    "id": "settings.update",
    "defaultMessage": "Update"
  },
  accountIntro: {
    "id": "settings.accountIntro",
    "defaultMessage": "Data concerns your account:"
  },
  oldPassword: {
    "id": "settings.oldPassword",
    "defaultMessage": "Old password"
  },
  newPassword: {
    "id": "settings.newPassword",
    "defaultMessage": "New password"
  },
  newPasswordAgain: {
    "id": "settings.newPasswordAgain",
    "defaultMessage": "New password again"
  },
  passwordChange: {
    "id": "settings.passwordChange",
    "defaultMessage": "Password change"
  },
  changePassword: {
    "id": "settings.changePassword",
    "defaultMessage": "Change password"
  },
  emailChange: {
    "id": "settings.emailChange",
    "defaultMessage": "Change email address"
  },
  newEmailAddress: {
    "id": "settings.newEmailAddress",
    "defaultMessage": "New email address"
  },
  currentPassword: {
    "id": "settings.currentPassword",
    "defaultMessage": "Current password"
  },
  changeEmail: {
    "id": "settings.changeEmail",
    "defaultMessage": "Change email"
  },
  emailChangeVerificationSent: {
    "id": "settings.emailChangeVerificationSent",
    "defaultMessage": "A verification email has been sent to your new email address. Please check your inbox and click the link to confirm the change."
  },
  emailChangeConfirmation: {
    "id": "settings.emailChangeConfirmation",
    "defaultMessage": "Email Change Confirmation"
  },
  emailChangeSuccess: {
    "id": "settings.emailChangeSuccess",
    "defaultMessage": "Your email has been successfully changed to {newEmail}."
  },
  emailChangeFailure: {
    "id": "settings.emailChangeFailure",
    "defaultMessage": "The email change link is invalid or has expired."
  },
  weatherServices: {
    "id": "settings.weatherServices",
    "defaultMessage": "Weather Services"
  },
  weatherServicesDescription: {
    "id": "settings.weatherServicesDescription",
    "defaultMessage": "Connect Netatmo, Davis, Weatherflow, and more"
  },
  weatherServicesConnected: {
    "id": "settings.weatherServicesConnected",
    "defaultMessage": "{count, plural, =0 {No services connected} one {# service connected} other {# services connected}}"
  },
  premium: {
    "id": "settings.premium",
    "defaultMessage": "SmartMixin Premium"
  },
  premiumDescription: {
    "id": "settings.premiumDescription",
    "defaultMessage": "Manage your subscription"
  },
  premiumActive: {
    "id": "settings.premiumActive",
    "defaultMessage": "Active"
  },
  premiumInactive: {
    "id": "settings.premiumInactive",
    "defaultMessage": "Not subscribed"
  },
  premiumSubscribedOn: {
    "id": "settings.premiumSubscribedOn",
    "defaultMessage": "Subscribed on {platform}"
  },
  premiumExpiresOn: {
    "id": "settings.premiumExpiresOn",
    "defaultMessage": "Renews on {date}"
  },
  premiumWebappNotice: {
    "id": "settings.premiumWebappNotice",
    "defaultMessage": "Subscriptions can only be purchased through the SmartMixin mobile app on iOS or Android."
  },
  premiumDownloadApp: {
    "id": "settings.premiumDownloadApp",
    "defaultMessage": "Download the app to subscribe:"
  },
  premiumCurrentPlan: {
    "id": "settings.premiumCurrentPlan",
    "defaultMessage": "Current Plan"
  },
  premiumFreePlan: {
    "id": "settings.premiumFreePlan",
    "defaultMessage": "Free"
  },
  premiumPremiumPlan: {
    "id": "settings.premiumPremiumPlan",
    "defaultMessage": "Premium"
  },
  light: {
    "id": "settings.light",
    "defaultMessage": "Light theme"
  },
  dark: {
    "id": "settings.dark",
    "defaultMessage": "Dark theme"
  },
  systemTheme: {
    "id": "settings.systemTheme",
    "defaultMessage": "System theme"
  },
  english: {
    "id": "settings.english",
    "defaultMessage": "English"
  },
  french: {
    "id": "settings.french",
    "defaultMessage": "French"
  },
  german: {
    "id": "settings.german",
    "defaultMessage": "German"
  },
  spanish: {
    "id": "settings.spanish",
    "defaultMessage": "Spanish"
  },
  italian: {
    "id": "settings.italian",
    "defaultMessage": "Italian"
  },
  polish: {
    "id": "settings.polish",
    "defaultMessage": "Polish"
  },
  hungarian: {
    "id": "settings.hungarian",
    "defaultMessage": "Hungarian"
  },
  swedish: {
    "id": "settings.swedish",
    "defaultMessage": "Swedish"
  },
  czech: {
    "id": "settings.czech",
    "defaultMessage": "Czech"
  },
  dutch: {
    "id": "settings.dutch",
    "defaultMessage": "Dutch"
  },
  danish: {
    "id": "settings.danish",
    "defaultMessage": "Danish"
  },
  serbian: {
    "id": "settings.serbian",
    "defaultMessage": "Serbian"
  },
  croatian: {
    "id": "settings.croatian",
    "defaultMessage": "Croatian"
  },
  norwegian: {
    "id": "settings.norwegian",
    "defaultMessage": "Norwegian"
  },
  portuguese: {
    "id": "settings.portuguese",
    "defaultMessage": "Portuguese"
  },
  slovak: {
    "id": "settings.slovak",
    "defaultMessage": "Slovak"
  },
  bulgarian: {
    "id": "settings.bulgarian",
    "defaultMessage": "Bulgarian"
  },
  russian: {
    "id": "settings.russian",
    "defaultMessage": "Russian"
  },
  ukrainian: {
    "id": "settings.ukrainian",
    "defaultMessage": "Ukrainian"
  },
  japanese: {
    "id": "settings.japanese",
    "defaultMessage": "Japanese"
  },
  korean: {
    "id": "settings.korean",
    "defaultMessage": "Korean"
  },
  turkish: {
    "id": "settings.turkish",
    "defaultMessage": "Turkish"
  },
  greek: {
    "id": "settings.greek",
    "defaultMessage": "Greek"
  },
  arabic: {
    "id": "settings.arabic",
    "defaultMessage": "Arabic"
  },
  gestures: {
    "id": "settings.gestures",
    "defaultMessage": "Gestures"
  },
  chartGestures: {
    "id": "settings.chartGestures",
    "defaultMessage": "Gestures on charts"
  },
  chartGesturesDescription: {
    "id": "settings.chartGesturesDescription",
    "defaultMessage": "Swiping on charts changes the time period, pinching charts changes time scale"
  },
  dateAndTime: {
    "id": "settings.dateAndTime",
    "defaultMessage": "Date and time"
  },
  connectedAccounts: {
    "id": "settings.connectedAccounts",
    "defaultMessage": "Connected Accounts"
  },
  connectedAccountsDescription: {
    "id": "settings.connectedAccountsDescription",
    "defaultMessage": "Apple, Google, Facebook"
  },
  socialConnectionsIntro: {
    "id": "settings.socialConnectionsIntro",
    "defaultMessage": "Link your social accounts to enable quick sign-in. You can connect or disconnect accounts at any time."
  },
  connected: {
    "id": "settings.connected",
    "defaultMessage": "Connected"
  },
  notConnected: {
    "id": "settings.notConnected",
    "defaultMessage": "Not connected"
  },
  connect: {
    "id": "settings.connect",
    "defaultMessage": "Connect"
  },
  disconnect: {
    "id": "settings.disconnect",
    "defaultMessage": "Disconnect"
  },
  disconnectConfirmation: {
    "id": "settings.disconnectConfirmation",
    "defaultMessage": "Are you sure you want to disconnect your {provider} account?"
  },
  connectionSuccess: {
    "id": "settings.connectionSuccess",
    "defaultMessage": "{provider} account connected successfully"
  },
  disconnectionSuccess: {
    "id": "settings.disconnectionSuccess",
    "defaultMessage": "{provider} account disconnected successfully"
  },
  cannotDisconnectLastAccount: {
    "id": "settings.cannotDisconnectLastAccount",
    "defaultMessage": "Cannot disconnect your only login method. Please add another login method first."
  },
  statusBarWidget: {
    "id": "settings.statusBarWidget",
    "defaultMessage": "Status Bar Widget"
  },
  statusBarWidgetDescription: {
    "id": "settings.statusBarWidgetDescription",
    "defaultMessage": "Always-visible weather data"
  },
  ongoingNotificationEnabled: {
    "id": "settings.ongoingNotificationEnabled",
    "defaultMessage": "Enable ongoing notification"
  },
  ongoingNotificationStation: {
    "id": "settings.ongoingNotificationStation",
    "defaultMessage": "Weather station"
  },
  ongoingNotificationMetrics: {
    "id": "settings.ongoingNotificationMetrics",
    "defaultMessage": "Displayed metrics"
  },
  ongoingNotificationMetricsHint: {
    "id": "settings.ongoingNotificationMetricsHint",
    "defaultMessage": "Drag to reorder selected metrics"
  },
  ongoingNotificationPermissionRequired: {
    "id": "settings.ongoingNotificationPermissionRequired",
    "defaultMessage": "Notification permission is required"
  },
  // Addon sections
  connectedServices: {
    "id": "settings.connectedServices",
    "defaultMessage": "Connected",
    "description": "Addon sections"
  },
  availableServices: {
    "id": "settings.availableServices",
    "defaultMessage": "Available"
  },
  connectedSince: {
    "id": "settings.connectedSince",
    "defaultMessage": "Connected since {date}"
  },
  // Version
  appVersion: {
    "id": "settings.appVersion",
    "defaultMessage": "SmartMixin v{version}",
    "description": "Version"
  }
});